import { render, staticRenderFns } from "./common_chat.vue?vue&type=template&id=684af95c"
import script from "./common_chat.vue?vue&type=script&lang=js"
export * from "./common_chat.vue?vue&type=script&lang=js"
import style0 from "./common_chat.vue?vue&type=style&index=0&id=684af95c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports